/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ArtifactShareCandidate {
    getFixupPrototypeFunction() { return ArtifactShareCandidate.fixupPrototype; }

    static newInstance(model: Partial<ArtifactShareCandidate>): ArtifactShareCandidate {
        let obj = Object.assign(new ArtifactShareCandidate(), model);
        ArtifactShareCandidate.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ArtifactShareCandidate>): ArtifactShareCandidate {
        if (!model) return null;
        return ArtifactShareCandidate.newInstance(<ArtifactShareCandidate> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ArtifactShareCandidate) {
        if (!obj) return;

        models.ArtifactShareCandidate.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ArtifactShareCandidate): boolean {
        Object.setPrototypeOf(obj, ArtifactShareCandidate.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * ID of the candidate user
     */
    id: string;

    /**
     * Username of the candidate user
     */
    username: string;

    /**
     * Email of the candidate user
     */
    email: string;

}
